// extracted by mini-css-extract-plugin
module.exports = {"declaration":"_9GanyfwSy8NS3uJJ-UEdGA==","footer":"_10avn-Dryw4jFA6nAAa4ow=="};